import React  from 'react'
import DropDown from '../dropdown';
import { GetReservationCategories } from '../../../api/services/pms';

const ReservationCategoriesDropDown = ({...props}) => {
    return <DropDown search={false} api={GetReservationCategories} textField="Name" valueField="Id"  {...props}/>
}

export default ReservationCategoriesDropDown